export interface ExternalLinkIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const ExternalLinkIcon = ({
  width = 20,
  height = 20,
  className = '',
}: ExternalLinkIconProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
      />
    </svg>
  );
};
